<!-- 医院选择列表 -->
<template>
<div class='hos-list'>
  <van-popup v-model:show="isHosPopup" position="bottom" :style="{ height: '100%' }">
    <div class="search-content">
      <div class="searchTtile" :style="{'padding-top':utils.checkIsApp() ? (utils.isIphoneX()?'50px':'40px') : utils.isIphoneX()?'20px':'10px'}">
        <div class="cancelSearch" @click='handleCancel'>取消</div>
        <van-field
          class='input'
          ref="seach_input"
          @input='handleChange'
          placeholder="请输入医院名称进行搜索"
          v-model.trim="searchHosName"
        />
        <!-- <input class='input' ref="seach_input" @input='handleChange' placeholder="请输入医院名称进行搜索" v-model.trim="searchHosName" type="text"> -->
        <div class="confirmSearch" @click='confirmHospital'>创建医院</div>
      </div>
      <div class="searchList">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model:loading="loading"
            :finished="finished"
            :finished-text="hospitalList.length > 0 ? '没有更多了' : ''"
            @load="onLoad"
          >
            <ul v-if='hospitalList.length>0'>
              <li class='hos-item' v-for="(item, index) in hospitalList" :key="index">
                <div class="com-name" @click='handleSelectComName(item)'>{{item.comName}}</div>
                <img v-if='item.isVerify == 1 || item.isVerify == 3' src="../../assets/images/checked.png" alt="">
              </li>
            </ul>
            <div class="no-hospital" v-if="isLoading === false && hospitalList.length == 0">
              <div class="p_text">
                <p>没搜索到医院，</p>
                <p style="margin: 10px 0px;"> 请换个词再搜试试（如删除"省/市名称"） </p>
              </div>
              <div class="p_text"> 如仍未找到？请下载【感控工作间】APP注册创建 </div>
              <div class="please-call">
                有其他疑问？请联系
                <a href="tel:400-969-7756" style="color: #999; font-size: 14px">400-969-7756</a>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </van-popup>
  <van-dialog v-model="emptyResultFlag" title="温馨提示" @confirm="emptyResultFlag = false" @cancel="openCreateDialog" confirmButtonText="再去找找" cancelButtonText="创建医院" show-cancel-button>
    <div class="shareview-dialog-content">
      您搜索的【{{ this.searchHosName }}】系统内不存在，需要重新创建一家医院？
    </div>
  </van-dialog>
  <van-popup v-model:show="isShowCreateHospital" position="bottom" :style="{ height: '100%' }">
    <create-hospital ref="createHospital" :formObj="formObj" :hospitalName="searchHosName" v-on:handleBack="handleBack"></create-hospital>

  </van-popup>
</div>
</template>

<script>
import createHospital from "./createHospital.vue";
export default {
  props: {
    formObj: {
      type: Object,
      default: ()=>{},
    },
  },
  data() {
    return {
      isLoading: null,
      isShowCreateHospital: false,

      emptyResultFlag: false,
      searchHosName:'', // 当前搜索的医院名称
      currentComId:'', // 选择的医院id
      loading:false,
      finished:false,
      refreshing:false,
      isHosPopup:false,
      pageNum:1,
      hospitalList:[], // 医院列表
    };
  },
  components: {
    'create-hospital': createHospital
  },
  created() {

  },
  methods: {
    handleBack(){
      this.isHosPopup = false
      setTimeout(()=>{
        this.isShowCreateHospital = false
      },0)
    },
    confirmHospital() {
      if (this.searchHosName === "") {
        this.$toast("请先输入医院全称进行搜索");
        return false;
      }
      if (this.searchHosName.length < 4) {
        this.$toast("请先输入正确的医院名称");
        return false;
      }

      // if (
      //   !(
      //     "2" == this.$route.query.taskRang || "3" == this.$route.query.taskRang
      //   ) &&
      //   !this.forbidCreate &&
      //   this.$route.query.limitCreateHospital != 1 &&
      //   (this.$route.query.sceneId == 1 || !this.$route.query.sceneId)
      // ) {
      //   this.$toast("此学习考试任务不允许创建医院");
      //   return false;
      // }

      let params = {
        data:{
          comName: this.searchHosName,
        }
      };
      this.$http.checkCompanyExist(params).then((res) => {
        this.checkCompanyExist = res
        this.checkCompanyExistMethods()
      });
    },
    setCompany(val) {
      console.log(val, '查询医院成功后的接口返回第一条数据')
      if (val) {
        this.$store.commit('UPDATE_CREATEHOSINFO', {
          ...val, // 查询医院成功后的接口返回第一条数据
        })
      }
    },
    checkCompanyExistMethods() {
      if (
        this.checkCompanyExist.code === 0 ||
        this.checkCompanyExist.code === null
      ) {
        if (this.checkCompanyExist.data.limitCreateHospital == 1) {
          // 不允许创建医院
          this.forbidCreate = true;
          this.$toast("此学习考试任务不允许创建医院");
          return false;
        }

        if (!this.checkCompanyExist.data.companyExist) {
          // 有医院直接加入
          this.isHosPopup = false;
          this.setCompany( this.hospitalList[0] );
          return;
        }

        if (
          (this.checkCompanyExist.data.limitCreateHospital == 0 ||
            this.checkCompanyExist.data.limitCreateHospital == null) &&
          this.checkCompanyExist.data.companyExist
        ) {
          // 系统判断没有所在医院,但是允许创建医院
          this.emptyResultFlag = true;
        }
      }
    },
    openCreateDialog() {
      this.cnzzStat("创建医院", "点击创建医院按钮");
      if (this.searchHosName.length < 4) {
        this.$toast("请先输入正确的医院名称");
        return false;
      }

      this.isShowCreateHospital = true // 以组件形式实现
      return
      // 以路由形式实现
      this.$router.push({
        path: "coms",
        query: {
          // formItem: this.formItem,
          // taskId: this.$route.query.taskId,
          // domainCode: this.$route.query.domainCode,
          // taskType: this.$route.query.taskType,
          // validCode: this.$route.query.validCode,
          // taskRang: this.$route.query.taskRang,
          // taskName: this.$route.query.taskName,
          hospitalName: this.searchHosName,
          // sceneId: this.$route.query.sceneId,
          // isStudy: this.$route.query.isStudy,
          // isQuestionnairesurvey: this.$route.query.isQuestionnairesurvey,
        },
      });
    },
    onLoad() {
      if(this.refreshing){
        this.refreshing = false
        this.hospitalList = []
      }
      setTimeout(()=>{
        this.initHoslist();
      },500)
    },
    onRefresh() {
      // 清空列表数据
      this.hospitalList = []
      this.pageNum = 1;
      this.finished = false;
      this.loading = true
      this.onLoad();
    },
    // 输入框发生变化
    handleChange(){
      this.isLoading = null
      this.hospitalList = []
      this.pageNum = 1;
      this.finished = false;
      this.loading = true
      setTimeout(()=>{
        this.initHoslist()
      },300)
    },
    // 选择已有医院
    handleSelectComName(val){
      this.isHosPopup = false
      this.$emit('handleSelectComName', val)
    },
    // 取消选择
    handleCancel(){
      this.isHosPopup = false
      this.handleEmpty()
      this.$emit('handleCancel')
    },
    handleEmpty(){
      this.searchHosName = ''
      this.currentComId = ''
    },
    handleShowPopup(temp){
      this.pageNum = 1;
      this.finished = false;
      this.loading = true
      this.hospitalList = []
      this.isHosPopup = true
      this.handleEmpty()
      this.initHoslist()
      if(this.utils.isIosOrAndroidOrPc() != 'ios'){
        this.$nextTick(() => {
          this.$refs.seach_input.focus()
        })
      }
    },
    // 医院模糊搜索
    initHoslist: _.throttle(
      function () {
        this.isLoading = true
        let params = {
          comName: this.searchHosName,
          page: this.pageNum,
          rows: 20,
        };
        this.$http .searchCompanyByPage(params) .then((res) => {
          this.isLoading = false
          if (res.status == 200) {
            this.pageNum++
            this.loading = false
            if(res.hasOwnProperty('data')){
              this.hospitalList = [...this.hospitalList,...res.data]
            }
            if(res.hasOwnProperty('data')&&res.data.length < 20 || res.data == null || !res.hasOwnProperty('data')){
              console.log('进来');
              this.finished = true
            }
          }
        })
        .catch((err) => {
          this.loading = false
          this.isLoading = false
          console.log(err);
        });
      },
      300,
      { trailing: false }
    ),
  },
}
</script>
<style lang='scss' scoped>
.hos-list{
  .search-content{
    display: flex;
    flex-direction: column;
    height: 100vh;
    .searchTtile{
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .input{
        padding: 5px;
        width: 60%;
        border: 1px solid #ddd;
        border-radius: 6px;
        font-size: 16px; // iOS Safari 的默认行为，当 font-size 小于 16px 时会自动放大页面
      }
      /deep/ .van-field{
        padding: 4px;
      }
      .confirmSearch{
          min-width: 80px;
          padding: 6px;
          margin-left: 10px;
          font-size: 14px;
          text-align: center;
          border-radius: 6px;
          background: #039aff;
          color: #fff;
      }
      .cancelSearch{
        margin-right: 20px;
        color: #999;
      }
    }
    .searchList{
      flex: 1;
      overflow: scroll;
    }
    ul{
      .hos-item{
        padding:12px;
        display: flex;
        align-items: center;
        font-size: 16px;
        .com-name{
          text-align: left;
        }
        img{
          margin-left: 3px;
          width: 16vw;
        }
      }
    }
    .no-hospital{
      margin-top: 40px;
      color: #000;
      font-size: 14px;
      .p_text{
  
      }
      .please-call{
        position: fixed;
        bottom: 120px;
        color: #999;
        left: 50%;
        width: 100%;
        transform: translateX(-50%);
        font-size: 14px;
        text-align: center;
      }
    }
  }
  .shareview-dialog-content {
    padding: 10px 20px;
  }
}
</style>